import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomAnalyticsFilled = createSvgIcon(
  <path d="M20.8 20.7H5.3c-1.1 0-2.1-.9-2.1-2.1V3.3h2v15.5h15.6zM7.5 8.3h2.3v7.9H7.5zm6.6-3.4h-2.2v11.3h2.2zm2.2 6.5h2.2v4.8h-2.2z" />,
  'CustomAnalyticsFilled',
);

export default CustomAnalyticsFilled;
